<template>
<router-view />
</template>

<script>
export default {
  name: 'DataDisplayPM',
  routeInfo: {
    label: '颗粒物',
    icon: 'fa fa-users'
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/03Data-Display/01PM/index.vue